import { CommonCodeList } from "@/comn/comn/code/ComnCdLst";
import { CityCodeList } from "@/comn/comn/code/CityCdLst";
import { CountryCodeList } from "@/comn/comn/code/CntyCdLst";
import { DgtCountryCodeList } from "@/comn/comn/code/dgt3CntyCdLst";
import { DgtNumCountryCodeList } from "@/comn/comn/code/Dgt3NumCntyCdLst";
import { CurrencyCodeList } from "@/comn/comn/code/CurrCdLst";
import { BankCodeList } from "@/comn/comn/code/BnkCdLst";
import { PortCodeList } from "@/comn/comn/code/PortCdLst";
import { AirptCodeList } from "@/comn/comn/code/AirptCdLst";
import { PortAirptCodeList } from "@/comn/comn/code/PortAirptCdLst";
import { CompanyCodeList } from "@/comn/comn/code/CoCdLst";
import { ProcessingStatusCodeList } from "@/comn/comn/code/PrcssStatCdLst";
import { OrganizationCodeList } from "@/comn/comn/code/OrgCdLst";
import { WrhsCodeList } from "@/comn/comn/code/WrhsCdLst";
import { CarrCodeList } from "@/comn/comn/code/CarrCdLst";
import { VehicleUseCodeList } from "@/comn/comn/code/VhclUseCdLst";
import { OrganizationDepartmentCodeList } from "@/comn/comn/code/OrgDeptCdLst";
import { VehicleBodyCodeList } from "@/comn/comn/code/VhclBodyCdLst";
import { VehicleCategoryCodeList } from "@/comn/comn/code/VhclCtgrCdLst";
import { VehicleColorCodeList } from "@/comn/comn/code/VhclClrCdLst";
import { VehicleFuelCodeList } from "@/comn/comn/code/VhclFlCdLst";
import { VehicleManufactureCodeList } from "@/comn/comn/code/VhclMkerCdLst";
import { VehicleImportCountryCodeList } from "@/comn/comn/code/VhclImpCntyCdLst";
import { VehicleInsuranceTypeCodeList } from "@/comn/comn/code/VhclInsrTpCdLst";
import { VehicleModelCodeList } from "@/comn/comn/code/VhclMdlCdLst";
import { VehicleModelNumberCodeList } from "@/comn/comn/code/VhclMdlNoCdLst";
import { VehicleHolderCategoryList } from "@/comn/comn/code/VhclHlpnCtgrCdLst";
import { VehiclePropellerTypeCodeList } from "@/comn/comn/code/VhclPrplTpCdLst";
import { VehicleTransmissionTypeCodeList } from "@/comn/comn/code/VhclTrmssnTpCdLst";
import { CompanyDeclareCodeList } from "@/comn/comn/code/CoDclaCdLst";
import { CustomsCodeList } from "@/comn/comn/code/cstmCdLst";
import { CustomsOfficerCodeList } from "@/comn/comn/code/CstmOfcrCdLst";
import { CustomsOrganizationCodeList } from "@/comn/comn/code/CstmOrgzCdLst";
import { HsCodeList } from "@/comn/comn/code/hsCdLst";
import { CompanyCodeDetail } from "@/comn/comn/code/CoCdDtl";
import { PostCodeList } from "@/comn/comn/code/PostCdLst";
import { TinNumberList } from "@/comn/comn/code/TinNoLst";
import { UcrNumberList } from "@/comn/comn/code/UcrNoLst";
import { EpcCodeList } from "@/comn/comn/code/EpcCdList";
import { ApcCodeList } from "@/comn/comn/code/ApcCdList";
import { TerminalOperatorCodeList } from "@/comn/comn/code/TrmnlOptrCdLst";
import { TbList } from "@/comn/comn/code/TbLst";
import { IndvCdTbList } from "@/comn/comn/code/IndvCdTbLst";
import { ColList } from "@/comn/comn/code/ColLst";
import { IndvCdColList } from "@/comn/comn/code/IndvCdColLst";
import { LblList } from "@/comn/comn/code/LblLst";
import { ComnCdMstrList } from "@/comn/comn/code/ComnCdMstrLst";
import { DcltList } from "@/comn/comn/code/DcltLst";
import { CoUsrList } from "@/comn/comn/code/CoUsrLst";
import { OrgUsrList } from "@/comn/comn/code/OrgUsrLst";
import { CoBucnList } from "@/comn/comn/code/CoBucnLst";
import { OrgzLst } from "@/comn/comn/code/OrgzLst";
import { OrgzSubLst } from "@/comn/comn/code/OrgzSubLst";
import { OrgzUsrRgsrLst } from "@/comn/comn/code/OrgzUsrRgsrLst";
import { HldyList } from "@/comn/comn/code/HldyLst";
import { CsldrTinList } from "@/comn/comn/code/CsldrTinLst";
import { RoleCodeList } from "@/comn/comn/code/RoleCdLst";

/*
 * 임시 컴포넌트 입니다
 * 해당 컴포넌트를 import 하지 마세요
 */

const ComnCodeModule = (props: any) => {
    const { COMN_CODE, callback, params } = props;

    switch (COMN_CODE) {
        case "comn:comnCd":
            return <CommonCodeList {...props} />;
        case "comn:cityCd":
            return <CityCodeList {...props} />;
        case "comn:unLocCd":
            return <CityCodeList {...props} />;
        case "comn:cntyCd":
            return <CountryCodeList {...props} />;
        case "comn:dgt3CntyCd":
            return <DgtCountryCodeList {...props} />;
        case "comn:dgt3NumCntyCd":
            return <DgtNumCountryCodeList {...props} />;
        case "comn:bnkCd":
            return <BankCodeList {...props} />;
        case "comn:currCd":
            return <CurrencyCodeList {...props} />;
        case "comn:portCd":
            return <PortCodeList {...props} />;
        case "comn:portAirptCd":
            return <PortAirptCodeList {...props} />;
        case "comn:airptCd":
            return <AirptCodeList {...props} />;
        case "comn:coCd":
            return <CompanyCodeList {...props} />;
        case "comn:prcssStatCd":
            return <ProcessingStatusCodeList {...props} />;
        case "comn:orgCd":
            return <OrganizationCodeList {...props} />;
        case "comn:wrhsCd":
            return <WrhsCodeList {...props} />;
        case "comn:carrCd":
            return <CarrCodeList {...props} />;
        case "comn:coDclaCd":
            return <CompanyDeclareCodeList {...props} />;
        case "comn:orgDeptCd":
            return <OrganizationDepartmentCodeList {...props} />;
        case "comn:cstmCd":
            return <CustomsCodeList {...props} />;
        case "comn:cstmOfcrCd":
            return <CustomsOfficerCodeList {...props} />;
        case "comn:cstmOrgzCd":
            return <CustomsOrganizationCodeList {...props} />;
        case "comn:vhclBodyCd":
            return <VehicleBodyCodeList {...props} />;
        case "comn:vhclCtgrCd":
            return <VehicleCategoryCodeList {...props} />;
        case "comn:vhclClrCd":
            return <VehicleColorCodeList {...props} />;
        case "comn:vhclFlCd":
            return <VehicleFuelCodeList {...props} />;
        case "comn:vhclMkerCd":
            return <VehicleManufactureCodeList {...props} />;
        case "comn:vhclImpCntyCd":
            return <VehicleImportCountryCodeList {...props} />;
        case "comn:vhclInsrTpCd":
            return <VehicleInsuranceTypeCodeList {...props} />;
        case "comn:vhclMdlCd":
            return <VehicleModelCodeList {...props} />;
        case "comn:vhclMdlNoCd":
            return <VehicleModelNumberCodeList {...props} />;
        case "comn:vhclHlpnCtgrCd":
            return <VehicleHolderCategoryList {...props} />;
        case "comn:vhclPrplTpCd":
            return <VehiclePropellerTypeCodeList {...props} />;
        case "comn:vhclTrmssnTpCd":
            return <VehicleTransmissionTypeCodeList {...props} />;
        case "comn:vhclUseCd":
            return <VehicleUseCodeList {...props} />;
        case "comn:coCdDtl":
            return <CompanyCodeDetail {...props} />;
        case "comn:hsCd":
            return <HsCodeList {...props} />;
        case "comn:postCd":
            return <PostCodeList {...props} />;
        case "comn:tinNo":
            return <TinNumberList {...props} />;
        case "comn:ucrNo":
            return <UcrNumberList {...props} />;
        case "comn:epcCd":
            return <EpcCodeList {...props} />;
        case "comn:apcCd":
            return <ApcCodeList {...props} />;
        case "comn:trmnlOptrCd":
            return <TerminalOperatorCodeList {...props} />;
        case "comn:tb":
            return <TbList {...props} />;
        case "comn:indvCdTb":
            return <IndvCdTbList {...props} />;
        case "comn:col":
            return <ColList {...props} />;
        case "comn:indvCdCol":
            return <IndvCdColList {...props} />;
        case "comn:lbl":
            return <LblList {...props} />;
        case "comn:comnCdMstr":
            return <ComnCdMstrList {...props} />;
        case "comn:dclt":
            return <DcltList {...props} />;
        case "comn:coUsr":
            return <CoUsrList {...props} />;
        case "comn:orgUsr":
            return <OrgUsrList {...props} />;
        case "comn:coBucn":
            return <CoBucnList {...props} />;
        case "comn:orgz":
            return <OrgzLst {...props} />;
        case "comn:orgzUsrRgsr":
            return <OrgzUsrRgsrLst {...props} />;
        case "comn:orgzSub":
            return <OrgzSubLst {...props} />;
        case "comn:hldy":
            return <HldyList {...props} />;
        case "comn:csldrTin":
            return <CsldrTinList {...props} />;
        case "comn:roleCd":
            return <RoleCodeList {...props} />;
        default:
            return <div></div>;
    }
};

export default ComnCodeModule;
